/*
	Components specified as react-data-grid `headerRenderer`s only receive a `column` prop,
	so to use this as a selection column header, you must include a `selectAll` function
	and `isAllSelected` boolean in the column definition.

	e.g.
	```
		{
			key: "idSelector",
			name: "",
			formatter: SelectItem,
			headerRenderer: SelectAllCell,
			selectAll,
			isAllSelected,
		}
	```
*/

import React from "react";
import { noop } from "utils/common";

export default function SelectAllCell({ column: { selectAll = noop, isAllSelected = false }, className = '' }){
	return (
		<label className={`select-cell select-all-cell checkbox-select-container ${className}`}>
			<input
				type="checkbox"
				checked = {isAllSelected}
				className="custom-checkbox"
				onChange = {(e) => {
					let { currentTarget: { checked } } = e;
					selectAll(checked);
				}}
			/>
			<span className="pretty-checkbox" />
		</label>
	);
}

SelectAllCell.displayName = "SelectAllCell";
